var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    fillOpacity: 0.2,
    style: {
      fill: "white",
      fillOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5734_97914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83095 16.5C5.68102 16.5 5 15.8502 5 14.7563V9.25451C5 8.13899 5.72567 7.5 6.83095 7.5H12.9713C14.1324 7.5 14.7353 8.13899 14.7353 9.25451V14.7563C14.7353 15.8502 14.0654 16.5 12.9155 16.5H6.83095ZM15.3828 13.5217V10.4783L17.638 8.61552C17.8278 8.4639 18.0734 8.35559 18.2744 8.35559C18.7097 8.35559 19 8.65884 19 9.12455V14.8755C19 15.3519 18.7097 15.6553 18.2744 15.6553C18.0734 15.6553 17.8389 15.5469 17.638 15.3844L15.3828 13.5217Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5734_97914",
    x: 4,
    y: 7.5,
    width: 16,
    height: 11,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5734_97914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5734_97914",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo1);
export default __webpack_public_path__ + "static/media/video_1.e2d4c79322ab7ba0b48a3bea4d0e66d6.svg";
export { ForwardRef as ReactComponent };